export enum factorySkillEnum {
  版房 = 0,
  裁床 = 1,
  车缝 = 3,
  尾部 = 4,
  加工 = 5,
  测试 = 6,
}
